export default function KraNameReview({ name, status }) {
  const reason = status?.kraTaxpayerName && !status?.kraNameMatches
    ? "The names do not match."
    : status?.message || "Verification unavailable.";

  return (
    <>
      <p>Name entered: {name || "Not available"}</p>
      <p>Verified Name: {status?.kraTaxpayerName || "Not available"}</p>
      {!status?.kraNameMatches && <p>Reason: {reason}</p>}
    </>
  );
}
